export default __webpack_public_path__ + "static/media/addItem.5c7ab259.svg";